// import React, { useState, useEffect, useMemo } from 'react';
// import {
//   BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer
// } from 'recharts';
// import {
//   CheckCircle, AlertTriangle, Clock, Calendar, Activity, X, Users
// } from 'lucide-react';

// const AttendanceDashboard = () => {
//   const [attendance, setAttendance] = useState([]);
//   const [employees, setEmployees] = useState({});
//   const [isVisible, setIsVisible] = useState(false);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [selectedMonth, setSelectedMonth] = useState(null);
//   const [selectedStatus, setSelectedStatus] = useState(null); // New state for status filter
//   const [statusDate, setStatusDate] = useState(new Date().toISOString().split('T')[0]); // Date for status filter

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         setLoading(true);
//         setError(null);

//         const token = localStorage.getItem('authToken');
//         const companyId = localStorage.getItem('selectedCompanyId');

//         if (!token) {
//           throw new Error('No authentication token found');
//         }

//         console.log('🔍 Fetching attendance data...', { companyId });

//         let attendanceData = [];

//         try {
//           console.log('🔄 Trying company attendance endpoint...');
//           const response = await fetch(`https://slateblue-mallard-430836.hostingersite.com/api/attendance/company/${companyId}`, {
//             headers: {
//               'Authorization': `Bearer ${token}`,
//               'Content-Type': 'application/json'
//             }
//           });

//           if (response.ok) {
//             const data = await response.json();
//             console.log('✅ Company attendance data received:', data);

//             if (Array.isArray(data)) {
//               attendanceData = data;
//             } else if (data.data && Array.isArray(data.data)) {
//               attendanceData = data.data;
//             } else if (data.attendance && Array.isArray(data.attendance)) {
//               attendanceData = data.attendance;
//             } else if (data.records && Array.isArray(data.records)) {
//               attendanceData = data.records;
//             }
//           } else {
//             console.warn('⚠️ Company attendance endpoint failed:', response.status);
//           }
//         } catch (companyErr) {
//           console.warn('⚠️ Company attendance endpoint error:', companyErr.message);
//         }

//         if (attendanceData.length === 0) {
//           try {
//             console.log('🔄 Trying general attendance endpoint...');
//             const response = await fetch('https://slateblue-mallard-430836.hostingersite.com/api/attendance/', {
//               headers: {
//                 'Authorization': `Bearer ${token}`,
//                 'Content-Type': 'application/json'
//               }
//             });

//             if (response.ok) {
//               const data = await response.json();
//               console.log('✅ General attendance data received:', data);

//               let allAttendance = [];
//               if (Array.isArray(data)) {
//                 allAttendance = data;
//               } else if (data.data && Array.isArray(data.data)) {
//                 allAttendance = data.data;
//               } else if (data.attendance && Array.isArray(data.attendance)) {
//                 allAttendance = data.attendance;
//               } else if (data.records && Array.isArray(data.records)) {
//                 allAttendance = data.records;
//               }

//               if (companyId && allAttendance.length > 0) {
//                 attendanceData = allAttendance.filter(record => {
//                   const recordCompanyId = record.company?._id || record.company || record.companyId;
//                   return recordCompanyId === companyId;
//                 });
//                 console.log(`Filtered ${attendanceData.length} records for company ${companyId}`);
//               } else {
//                 attendanceData = allAttendance;
//               }
//             }
//           } catch (generalErr) {
//             console.warn('⚠️ General attendance endpoint error:', generalErr.message);
//           }
//         }

//         if (attendanceData.length === 0) {
//           console.log('🔄 No attendance data found, using sample data for demonstration...');
//           // attendanceData = generateSampleData();
//         }

//         console.log('📊 Final attendance data:', attendanceData.length, 'records');
//         setAttendance(attendanceData);

//         // Extract unique employeeIds and fetch employees
//         const employeeIds = [...new Set(attendanceData.map(record => 
//           record.employeeId || record.employee?._id || record.employee || null
//         ).filter(id => id && id !== 'null'))];

//         console.log('👥 Employee IDs to fetch:', employeeIds);

//         if (employeeIds.length > 0) {
//           await fetchEmployees(employeeIds, token);
//         } else {
//           console.log('⚠️ No employee IDs found in attendance data');
//         }

//       } catch (err) {
//         console.error('❌ Error fetching attendance:', err);
//         setError(err.message);
//         console.log('🔄 Using sample data as fallback...');
//         // setAttendance(generateSampleData());
//       } finally {
//         setLoading(false);
//         setIsVisible(true);
//       }
//     };

//     const fetchEmployees = async (employeeIds, token) => {
//       try {
//         console.log('🔄 Fetching employees data...', employeeIds);

//         let employeesData = [];

//         try {
//           const companyId = localStorage.getItem('selectedCompanyId');
//           const response = await fetch(`https://slateblue-mallard-430836.hostingersite.com/api/employees/company/${companyId}`, {
//             headers: {
//               'Authorization': `Bearer ${token}`,
//               'Content-Type': 'application/json'
//             }
//           });

//           if (response.ok) {
//             const data = await response.json();
//             console.log('✅ All company employees received:', data);

//             if (Array.isArray(data)) {
//               employeesData = data;
//             } else if (data.data && Array.isArray(data.data)) {
//               employeesData = data.data;
//             } else if (data.employees && Array.isArray(data.employees)) {
//               employeesData = data.employees;
//             }
//           }
//         } catch (err) {
//           console.warn('⚠️ Error fetching all employees:', err.message);
//         }

//         if (employeesData.length === 0) {
//           console.log('🔄 Trying individual employee endpoints...');
//           for (const id of employeeIds) {
//             try {
//               const response = await fetch(`https://slateblue-mallard-430836.hostingersite.com/api/employees/${id}`, {
//                 headers: {
//                   'Authorization': `Bearer ${token}`,
//                   'Content-Type': 'application/json'
//                 }
//               });

//               if (response.ok) {
//                 const employee = await response.json();
//                 employeesData.push(employee);
//               }
//             } catch (err) {
//               console.warn(`⚠️ Error fetching employee ${id}:`, err.message);
//             }
//           }
//         }

//         const employeesMap = {};
//         employeesData.forEach(emp => {
//           if (emp && emp._id) {
//             employeesMap[emp._id] = emp.teamMemberName || emp.name || 'Unknown Employee';
//           }
//         });

//         console.log('👥 Employee mapping created:', employeesMap);
//         setEmployees(employeesMap);

//       } catch (err) {
//         console.error('❌ Error fetching employees:', err);
//       }
//     };

//     // const generateSampleData = () => {
//     //   const sampleData = [];
//     //   const statuses = ['present', 'absent', 'late'];
//     //   const today = new Date();
//     //   const sampleEmployees = [
//     //     { id: '68c3ab4ad22f449783c680da', name: 'Aditya' },
//     //     { id: '68c40c9d7e6320c4880de2af', name: 'Avantika' },
//     //     { id: '68c4514a9f78adf639b4170b', name: 'Aditi' }
//     //   ];

//     //   for (let i = 0; i < 30; i++) {
//     //     const date = new Date(today);
//     //     date.setDate(date.getDate() - i);
//     //     const employee = sampleEmployees[Math.floor(Math.random() * sampleEmployees.length)];
//     //     const status = statuses[Math.floor(Math.random() * statuses.length)];
//     //     const inTime = status === 'present' || status === 'late' ? 
//     //       `09:${Math.floor(Math.random() * 30)}:00` : null;

//     //     sampleData.push({
//     //       _id: `sample-${i}`,
//     //       status: status,
//     //       date: date.toISOString().split('T')[0],
//     //       inTime: inTime,
//     //       outTime: status === 'present' ? `17:${Math.floor(Math.random() * 60)}:00` : null,
//     //       isHoliday: Math.random() > 0.9,
//     //       leaveRequestId: Math.random() > 0.8 ? `leave-${i}` : null,
//     //       leaveType: Math.random() > 0.8 ? 'Sick Leave' : null,
//     //       employeeId: employee.id,
//     //       employee: { _id: employee.id, name: employee.name }
//     //     });
//     //   }

//     //   const sampleEmployeesMap = {};
//     //   sampleEmployees.forEach(emp => {
//     //     sampleEmployeesMap[emp.id] = emp.name;
//     //   });
//     //   setEmployees(sampleEmployeesMap);

//     //   return sampleData;
//     // };

//     fetchData();
//   }, []);

//   const CountUp = ({ end, duration = 2000 }) => {
//     const [count, setCount] = useState(0);
//     useEffect(() => {
//       let start = 0;
//       const increment = end / (duration / 16);
//       const timer = setInterval(() => {
//         start += increment;
//         if (start >= end) {
//           setCount(end);
//           clearInterval(timer);
//         } else {
//           setCount(Math.floor(start));
//         }
//       }, 16);
//       return () => clearInterval(timer);
//     }, [end, duration]);
//     return <span>{count}</span>;
//   };

//   const processedData = useMemo(() => {
//     if (!Array.isArray(attendance) || attendance.length === 0) {
//       return { todayAttendance: { present: 0, absent: 0, late: 0, holidays: 0, leaves: 0 }, attendanceData: [], leaveData: [], holidayData: [] };
//     }

//     const normalize = (record) => ({
//       id: record._id || record.id,
//       status: (record.status || record.Status || '').trim().toLowerCase(),
//       date: record.date || record.Date || (record.inTime ? record.inTime.split('T')[0] : ''),
//       inTime: record.inTime || record.checkIn || record.CheckIn || '',
//       outTime: record.outTime || record.checkOut || record.CheckOut || '',
//       leaveRequestId: record.leaveRequestId || record.LeaveRequestId || null,
//       leaveType: record.leaveType || record.LeaveType || null,
//       isHoliday: record.isHoliday || record.IsHoliday || false,
//       employee: record.employee || record.Employee || null,
//       employeeId: record.employeeId || record.employee?._id || record.employee || null,
//     });

//     const normalized = attendance.map(normalize);
//     const today = new Date().toISOString().split('T')[0];

//     const todayRecords = normalized.filter(r => r.date?.split('T')[0] === today);
//     const todayAttendance = {
//       present: todayRecords.filter(r => r.status === 'present' || (r.inTime && r.outTime)).length,
//       absent: todayRecords.filter(r => r.status === 'ul' || r.status === 'absent' || (!r.inTime && !r.isHoliday)).length,
//       late: todayRecords.filter(r => (r.status === 'present' || r.inTime) && r.inTime && new Date(`1970-01-01T${r.inTime.split('T')[1]}`) > new Date('1970-01-01T09:00:00')).length,
//       holidays: todayRecords.filter(r => r.isHoliday).length,
//       leaves: todayRecords.filter(r => r.leaveRequestId).length,
//     };

//     const last6Months = [];
//     for (let i = 5; i >= 0; i--) {
//       const date = new Date();
//       date.setMonth(date.getMonth() - i);
//       last6Months.push(date.toLocaleString('default', { month: 'short', year: 'numeric' }));
//     }

//     const grouped = {};
//     last6Months.forEach(monthKey => {
//       grouped[monthKey] = { name: monthKey, present: 0, absent: 0, late: 0, leave: 0, holiday: 0 };
//     });

//     normalized.forEach(r => {
//       if (!r.date) return;
//       try {
//         const recordDate = new Date(r.date);
//         const monthKey = recordDate.toLocaleString('default', { month: 'short', year: 'numeric' });
//         if (grouped[monthKey]) {
//           if (r.status === 'present' || (r.inTime && r.outTime)) {
//             grouped[monthKey].present++;
//             if (r.inTime) {
//               const inTimeStr = r.inTime.includes('T') ? r.inTime.split('T')[1] : r.inTime;
//               if (inTimeStr && new Date(`1970-01-01T${inTimeStr}`) > new Date('1970-01-01T09:00:00')) {
//                 grouped[monthKey].late++;
//               }
//             }
//           } else if (r.status === 'ul' || r.status === 'absent' || (!r.inTime && !r.isHoliday)) {
//             grouped[monthKey].absent++;
//           }
//           if (r.isHoliday) grouped[monthKey].holiday++;
//           if (r.leaveRequestId) grouped[monthKey].leave++;
//         }
//       } catch (err) {
//         console.warn('⚠️ Invalid date format:', r.date);
//       }
//     });

//     const attendanceData = Object.values(grouped);
//     const leaveData = normalized.filter(r => r.leaveRequestId).map(r => ({
//       reason: r.leaveType || 'Leave',
//       status: 'approved',
//       fromDate: r.date,
//       toDate: r.date,
//       employeeId: r.employeeId,
//     }));
//     const holidayData = normalized.filter(r => r.isHoliday).map(r => ({ name: 'Holiday', date: r.date }));

//     return { todayAttendance, attendanceData, leaveData, holidayData, normalized };
//   }, [attendance, employees]);

//   const { todayAttendance, attendanceData, leaveData, holidayData, normalized } = processedData;

//   // Get records for specific status and date
//   const getRecordsByStatus = (status, date = new Date().toISOString().split('T')[0]) => {
//     return normalized.filter(record => {
//       const recordDate = record.date?.split('T')[0];
//       if (recordDate !== date) return false;

//       switch (status) {
//         case 'present':
//           return record.status === 'present' || (record.inTime && record.outTime);
//         case 'absent':
//           return record.status === 'ul' || record.status === 'absent' || (!record.inTime && !record.isHoliday);
//         case 'late':
//           return (record.status === 'present' || record.inTime) && 
//                  record.inTime && 
//                  new Date(`1970-01-01T${record.inTime.split('T')[1]}`) > new Date('1970-01-01T09:00:00');
//         case 'holidays':
//           return record.isHoliday;
//         case 'leaves':
//           return record.leaveRequestId;
//         default:
//           return false;
//       }
//     });
//   };

//   const getRecordsForMonth = (monthString) => {
//     if (!monthString) return [];
//     const [monthName, year] = monthString.split(' ');
//     const monthIndex = new Date(`${monthName} 1, 2000`).getMonth();
//     return attendance.filter(record => {
//       if (!record.date) return false;
//       const recordDate = new Date(record.date);
//       return recordDate.getMonth() === monthIndex && recordDate.getFullYear() === parseInt(year);
//     });
//   };

//   // Helper function to get employee name
//   const getEmployeeName = (record) => {
//     const employeeId = record.employeeId || record.employee?._id || record.employee;
//     if (employees[employeeId]) {
//       return employees[employeeId];
//     }

//     if (record.employee && record.employee.teamMemberName) {
//       return record.employee.teamMemberName;
//     }
//     if (record.employee && record.employee.name) {
//       return record.employee.name;
//     }
//     if (record.employeeName) {
//       return record.employeeName;
//     }

//     return 'Unknown Employee';
//   };

//   // Status card click handler
//   const handleStatusClick = (status) => {
//     setSelectedStatus(status);
//     setStatusDate(new Date().toISOString().split('T')[0]);
//   };

//   // Get status display name
//   const getStatusDisplayName = (status) => {
//     const statusMap = {
//       present: 'Present',
//       absent: 'Absent',
//       late: 'Late Arrivals',
//       holidays: 'Holidays',
//       leaves: 'Leaves'
//     };
//     return statusMap[status] || status;
//   };

//   if (loading) {
//     return (
//       <div className="flex items-center justify-center h-64">
//         <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
//         <span className="ml-3 text-gray-600">Loading attendance data...</span>
//       </div>
//     );
//   }

//   return (
//     <div className={`space-y-6 transition-all duration-700 ease-in-out ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
//       {error && (
//         <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
//           <div className="flex items-center">
//             <AlertTriangle className="w-5 h-5 text-yellow-600 mr-2" />
//             <span className="text-yellow-800">Using sample data: {error}</span>
//           </div>
//         </div>
//       )}

//       {/* Status Cards */}
//       <div className="grid grid-cols-1 md:grid-cols-5 gap-6">
//         {[
//           { label: 'Present Today', value: todayAttendance.present, color: 'green', icon: <CheckCircle className="w-8 h-8 text-green-500" />, status: 'present' },
//           { label: 'Absent Today', value: todayAttendance.absent, color: 'red', icon: <AlertTriangle className="w-8 h-8 text-red-500" />, status: 'absent' },
//           { label: 'Late Arrivals', value: todayAttendance.late, color: 'yellow', icon: <Clock className="w-8 h-8 text-yellow-500" />, status: 'late' },
//           { label: 'Holidays Today', value: todayAttendance.holidays, color: 'purple', icon: <Calendar className="w-8 h-8 text-purple-500" />, status: 'holidays' },
//           { label: 'Leaves Today', value: todayAttendance.leaves, color: 'indigo', icon: <Activity className="w-8 h-8 text-indigo-500" />, status: 'leaves' },
//         ].map((item, i) => (



import React, { useState, useEffect, useMemo } from 'react';
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer
} from 'recharts';
import {
  CheckCircle, AlertTriangle, Clock, Calendar, Activity, X, Users
} from 'lucide-react';
import config from '../../config';
import { jwtDecode } from 'jwt-decode';

const AttendanceDashboard = () => {
  const [attendance, setAttendance] = useState([]);
  const [employees, setEmployees] = useState({});
  const [isVisible, setIsVisible] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null); // New state for status filter
  const [statusDate, setStatusDate] = useState(new Date().toISOString().split('T')[0]); // Date for status filter

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        setError(null);

        const token = localStorage.getItem('authToken');
        let companyId = localStorage.getItem('selectedCompanyId');

        if (!token) {
          throw new Error('No authentication token found');
        }

        if (!companyId) {
          console.warn('⚠️ No company ID found in localStorage, trying to decode from token...');
          try {
            const decoded = jwtDecode(token);
            companyId = decoded.companyId || decoded.id;
            if (companyId) localStorage.setItem('selectedCompanyId', companyId);
          } catch (e) {
            console.error('Failed to decode token for companyId:', e);
          }
        }

        console.log('🔍 Fetching attendance data...', { companyId });

        let attendanceData = [];

        try {
          console.log('🔄 Trying company attendance endpoint...');
          const response = await fetch(`https://slateblue-mallard-430836.hostingersite.com/api/attendance/company/${companyId}`, {
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            }
          });

          if (response.ok) {
            const data = await response.json();
            console.log('✅ Company attendance data received:', data);

            if (Array.isArray(data)) {
              attendanceData = data;
            } else if (data.data && Array.isArray(data.data)) {
              attendanceData = data.data;
            } else if (data.attendance && Array.isArray(data.attendance)) {
              attendanceData = data.attendance;
            } else if (data.records && Array.isArray(data.records)) {
              attendanceData = data.records;
            }
          } else {
            console.warn('⚠️ Company attendance endpoint failed:', response.status);
          }
        } catch (companyErr) {
          console.warn('⚠️ Company attendance endpoint error:', companyErr.message);
        }

        if (attendanceData.length === 0) {
          try {
            console.log('🔄 Trying general attendance endpoint...');
            const response = await fetch('https://slateblue-mallard-430836.hostingersite.com/api/attendance/', {
              headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
              }
            });

            if (response.ok) {
              const data = await response.json();
              console.log('✅ General attendance data received:', data);

              let allAttendance = [];
              if (Array.isArray(data)) {
                allAttendance = data;
              } else if (data.data && Array.isArray(data.data)) {
                allAttendance = data.data;
              } else if (data.attendance && Array.isArray(data.attendance)) {
                allAttendance = data.attendance;
              } else if (data.records && Array.isArray(data.records)) {
                allAttendance = data.records;
              }

              if (companyId && allAttendance.length > 0) {
                attendanceData = allAttendance.filter(record => {
                  const recordCompanyId = record.company?._id || record.company || record.companyId;
                  return recordCompanyId === companyId;
                });
                console.log(`🏢 Filtered ${attendanceData.length} records for company ${companyId}`);
              } else {
                attendanceData = allAttendance;
              }
            }
          } catch (generalErr) {
            console.warn('⚠️ General attendance endpoint error:', generalErr.message);
          }
        }

        console.log('📊 Final attendance data:', attendanceData.length, 'records');
        setAttendance(attendanceData);

        const employeeIds = [...new Set(attendanceData.map(record =>
          record.employeeId || record.employee?._id || record.employee || null
        ).filter(id => id && id !== 'null'))];

        console.log('👥 Employee IDs to fetch:', employeeIds);

        if (employeeIds.length > 0) {
          await fetchEmployees(employeeIds, token);
        } else {
          console.log('⚠️ No employee IDs found in attendance data');
        }

      } catch (err) {
        console.error('❌ Error fetching attendance:', err);
        setError(err.message);
        console.log('🔄 Using sample data as fallback...');
      } finally {
        setLoading(false);
        setIsVisible(true);
      }
    };

    const fetchEmployees = async (employeeIds, token) => {
      try {
        console.log('🔄 Fetching employees data...', employeeIds);

        let employeesData = [];

        try {
          const companyId = localStorage.getItem('selectedCompanyId');
          const response = await fetch(`https://slateblue-mallard-430836.hostingersite.com/api/employees/company/${companyId}`, {
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            }
          });

          if (response.ok) {
            const data = await response.json();
            console.log('✅ All company employees received:', data);

            if (Array.isArray(data)) {
              employeesData = data;
            } else if (data.data && Array.isArray(data.data)) {
              employeesData = data.data;
            } else if (data.employees && Array.isArray(data.employees)) {
              employeesData = data.employees;
            }
          }
        } catch (err) {
          console.warn('⚠️ Error fetching all employees:', err.message);
        }

        if (employeesData.length === 0) {
          console.log('🔄 Trying individual employee endpoints...');
          for (const id of employeeIds) {
            try {
              const response = await fetch(`https://slateblue-mallard-430836.hostingersite.com/api/employees/${id}`, {
                headers: {
                  'Authorization': `Bearer ${token}`,
                  'Content-Type': 'application/json'
                }
              });

              if (response.ok) {
                const employee = await response.json();
                employeesData.push(employee);
              }
            } catch (err) {
              console.warn(`⚠️ Error fetching employee ${id}:`, err.message);
            }
          }
        }

        const employeesMap = {};
        employeesData.forEach(emp => {
          if (emp && emp._id) {
            employeesMap[emp._id] = emp.teamMemberName || emp.name || 'Unknown Employee';
          }
        });

        console.log('👥 Employee mapping created:', employeesMap);
        setEmployees(employeesMap);

      } catch (err) {
        console.error('❌ Error fetching employees:', err);
      }
    };

    fetchData();
  }, []);

  const CountUp = ({ end, duration = 2000 }) => {
    const [count, setCount] = useState(0);
    useEffect(() => {
      let start = 0;
      const increment = end / (duration / 16);
      const timer = setInterval(() => {
        start += increment;
        if (start >= end) {
          setCount(end);
          clearInterval(timer);
        } else {
          setCount(Math.floor(start));
        }
      }, 16);
      return () => clearInterval(timer);
    }, [end, duration]);
    return <span>{count}</span>;
  };

  const processedData = useMemo(() => {
    if (!Array.isArray(attendance) || attendance.length === 0) {
      return { todayAttendance: { present: 0, absent: 0, late: 0, holidays: 0, leaves: 0 }, attendanceData: [], leaveData: [], holidayData: [] };
    }

    const normalize = (record) => ({
      id: record._id || record.id,
      status: (record.status || record.Status || '').trim().toLowerCase(),
      date: record.date || record.Date || (record.inTime ? record.inTime.split('T')[0] : ''),
      inTime: record.inTime || record.checkIn || record.CheckIn || '',
      outTime: record.outTime || record.checkOut || record.CheckOut || '',
      leaveRequestId: record.leaveRequestId || record.LeaveRequestId || null,
      leaveType: record.leaveType || record.LeaveType || null,
      isHoliday: record.isHoliday || record.IsHoliday || false,
      employee: record.employee || record.Employee || null,
      employeeId: record.employeeId || record.employee?._id || record.employee || null,
    });

    const normalized = attendance.map(normalize);
    const today = new Date().toISOString().split('T')[0];

    const todayRecords = normalized.filter(r => r.date?.split('T')[0] === today);
    const todayAttendance = {
      present: todayRecords.filter(r => r.status === 'present' || (r.inTime && r.outTime)).length,
      absent: todayRecords.filter(r => r.status === 'ul' || r.status === 'absent' || (!r.inTime && !r.isHoliday)).length,
      late: todayRecords.filter(r => (r.status === 'present' || r.inTime) && r.inTime && new Date(`1970-01-01T${r.inTime.split('T')[1]}`) > new Date('1970-01-01T09:00:00')).length,
      holidays: todayRecords.filter(r => r.isHoliday).length,
      leaves: todayRecords.filter(r => r.leaveRequestId).length,
    };

    const last6Months = [];
    for (let i = 5; i >= 0; i--) {
      const date = new Date();
      date.setMonth(date.getMonth() - i);
      last6Months.push(date.toLocaleString('default', { month: 'short', year: 'numeric' }));
    }

    const grouped = {};
    last6Months.forEach(monthKey => {
      grouped[monthKey] = { name: monthKey, present: 0, absent: 0, late: 0, leave: 0, holiday: 0 };
    });

    normalized.forEach(r => {
      if (!r.date) return;
      try {
        const recordDate = new Date(r.date);
        const monthKey = recordDate.toLocaleString('default', { month: 'short', year: 'numeric' });
        if (grouped[monthKey]) {
          if (r.status === 'present' || (r.inTime && r.outTime)) {
            grouped[monthKey].present++;
            if (r.inTime) {
              const inTimeStr = r.inTime.includes('T') ? r.inTime.split('T')[1] : r.inTime;
              if (inTimeStr && new Date(`1970-01-01T${inTimeStr}`) > new Date('1970-01-01T09:00:00')) {
                grouped[monthKey].late++;
              }
            }
          } else if (r.status === 'ul' || r.status === 'absent' || (!r.inTime && !r.isHoliday)) {
            grouped[monthKey].absent++;
          }
          if (r.isHoliday) grouped[monthKey].holiday++;
          if (r.leaveRequestId) grouped[monthKey].leave++;
        }
      } catch (err) {
        console.warn('⚠️ Invalid date format:', r.date);
      }
    });

    const attendanceData = Object.values(grouped);
    const leaveData = normalized.filter(r => r.leaveRequestId).map(r => ({
      reason: r.leaveType || 'Leave',
      status: 'approved',
      fromDate: r.date,
      toDate: r.date,
      employeeId: r.employeeId,
    }));
    const holidayData = normalized.filter(r => r.isHoliday).map(r => ({ name: 'Holiday', date: r.date }));

    return { todayAttendance, attendanceData, leaveData, holidayData, normalized };
  }, [attendance, employees]);

  const { todayAttendance, attendanceData, leaveData, holidayData, normalized } = processedData;

  const getRecordsByStatus = (status, date = new Date().toISOString().split('T')[0]) => {
    return normalized.filter(record => {
      const recordDate = record.date?.split('T')[0];
      if (recordDate !== date) return false;

      switch (status) {
        case 'present':
          return record.status === 'present' || (record.inTime && record.outTime);
        case 'absent':
          return record.status === 'ul' || record.status === 'absent' || (!record.inTime && !record.isHoliday);
        case 'late':
          return (record.status === 'present' || record.inTime) &&
            record.inTime &&
            new Date(`1970-01-01T${record.inTime.split('T')[1]}`) > new Date('1970-01-01T09:00:00');
        case 'holidays':
          return record.isHoliday;
        case 'leaves':
          return record.leaveRequestId;
        default:
          return false;
      }
    });
  };

  const getRecordsForMonth = (monthString) => {
    if (!monthString) return [];
    const [monthName, year] = monthString.split(' ');
    const monthIndex = new Date(`${monthName} 1, 2000`).getMonth();
    return attendance.filter(record => {
      if (!record.date) return false;
      const recordDate = new Date(record.date);
      return recordDate.getMonth() === monthIndex && recordDate.getFullYear() === parseInt(year);
    });
  };

  const getEmployeeName = (record) => {
    const employeeId = record.employeeId || record.employee?._id || record.employee;
    if (employees[employeeId]) {
      return employees[employeeId];
    }
    if (record.employee && record.employee.teamMemberName) {
      return record.employee.teamMemberName;
    }
    if (record.employee && record.employee.name) {
      return record.employee.name;
    }
    if (record.employeeName) {
      return record.employeeName;
    }
    return 'Unknown Employee';
  };

  const handleStatusClick = (status) => {
    setSelectedStatus(status);
    setStatusDate(new Date().toISOString().split('T')[0]);
  };

  const getStatusDisplayName = (status) => {
    const statusMap = {
      present: 'Present',
      absent: 'Absent',
      late: 'Late Arrivals',
      holidays: 'Holidays',
      leaves: 'Leaves'
    };
    return statusMap[status] || status;
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
        <span className="ml-3 text-gray-600">Loading attendance data...</span>
      </div>
    );
  }

  return (
    <div className={`space-y-6 transition-all duration-700 ease-in-out ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
      {error && (
        <div className="bg-slate-900 border border-amber-500/40 rounded-lg p-4">
          <div className="flex items-center">
            <AlertTriangle className="w-5 h-5 text-amber-400 mr-2" />
            <span className="text-amber-200">Using sample data: {error}</span>
          </div>
        </div>
      )}

      <div className="grid grid-cols-1 md:grid-cols-5 gap-6">
        {[
          { label: 'Present Today', value: todayAttendance.present, color: 'green', icon: <CheckCircle className="w-8 h-8 text-green-500" />, status: 'present' },
          { label: 'Absent Today', value: todayAttendance.absent, color: 'red', icon: <AlertTriangle className="w-8 h-8 text-red-500" />, status: 'absent' },
          { label: 'Late Arrivals', value: todayAttendance.late, color: 'yellow', icon: <Clock className="w-8 h-8 text-yellow-500" />, status: 'late' },
          { label: 'Holidays Today', value: todayAttendance.holidays, color: 'purple', icon: <Calendar className="w-8 h-8 text-purple-500" />, status: 'holidays' },
          { label: 'Leaves Today', value: todayAttendance.leaves, color: 'indigo', icon: <Activity className="w-8 h-8 text-indigo-500" />, status: 'leaves' },
        ].map((item, i) => (
          <div
            key={i}
            className="bg-white rounded-xl shadow-sm p-6 border border-gray-100 hover:shadow-lg transition-transform hover:-translate-y-1 cursor-pointer"
            onClick={() => handleStatusClick(item.status)}
          >
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-600">{item.label}</p>
                <p className="text-2xl font-bold text-gray-900"><CountUp end={item.value || 0} /></p>
              </div>
              {item.icon}
            </div>
          </div>
        ))}
      </div>

      {selectedStatus && (
        <div className="bg-slate-900 rounded-xl shadow-lg p-6 border border-slate-700">
          <div className="flex justify-between items-center mb-4">
            <div>
              <h3 className="text-lg font-semibold text-white">
                👥 {getStatusDisplayName(selectedStatus)} - {new Date(statusDate).toLocaleDateString('en-GB')}
              </h3>
              <p className="text-sm text-slate-400 mt-1">
                Total: {getRecordsByStatus(selectedStatus, statusDate).length} employees
              </p>
            </div>
            <button
              onClick={() => setSelectedStatus(null)}
              className="text-slate-400 hover:text-white"
            >
              <X className="w-5 h-5" />
            </button>
          </div>

          {(() => {
            const statusRecords = getRecordsByStatus(selectedStatus, statusDate);
            if (statusRecords.length > 0) {
              return (
                <div className="space-y-3">
                  {statusRecords.map(record => (
                    <div key={record.id} className="p-4 border border-slate-700 rounded-lg hover:bg-slate-800 transition-all">
                      <div className="flex items-center justify-between">
                        <div className="flex items-center space-x-3">
                          <div className="w-10 h-10 bg-slate-800 rounded-full flex items-center justify-center">
                            <Users className="w-5 h-5 text-sky-400" />
                          </div>
                          <div>
                            <h4 className="font-semibold text-white">
                              {getEmployeeName(record)}
                            </h4>
                            <p className="text-sm text-slate-400">
                              Employee ID: {record.employeeId || 'N/A'}
                            </p>
                          </div>
                        </div>
                        <div className="text-right">
                          {selectedStatus === 'present' || selectedStatus === 'late' ? (
                            <div className="space-y-1">
                              <p className="text-sm font-medium text-white">
                                In: {record.inTime || 'N/A'}
                              </p>
                              <p className="text-sm text-slate-400">
                                Out: {record.outTime || 'N/A'}
                              </p>
                            </div>
                          ) : selectedStatus === 'leaves' ? (
                            <div className="space-y-1">
                              <p className="text-sm font-medium text-white">
                                {record.leaveType || 'Leave'}
                              </p>
                              <p className="text-sm text-slate-400">
                                Approved
                              </p>
                            </div>
                          ) : (
                            <span className={`px-3 py-1 rounded-full text-sm font-medium ${selectedStatus === 'absent' ? 'bg-rose-500/20 text-rose-300' :
                              selectedStatus === 'holidays' ? 'bg-violet-500/20 text-violet-300' :
                                'bg-slate-700 text-slate-200'
                              }`}>
                              {getStatusDisplayName(selectedStatus)}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              );
            } else {
              return (
                <div className="text-center py-8">
                  <Users className="w-16 h-16 text-slate-500 mx-auto mb-4" />
                  <p className="text-slate-300 text-lg">No {getStatusDisplayName(selectedStatus).toLowerCase()} found for this date.</p>
                </div>
              );
            }
          })()}
        </div>
      )}

      <div className="bg-slate-900 rounded-xl shadow-lg p-6 border border-slate-700 hover:shadow-2xl">
        <h3 className="text-lg font-semibold text-white mb-4">📊 Monthly Attendance Overview</h3>
        {attendanceData.length > 0 ? (
          <ResponsiveContainer width="100%" height={400}>
            <BarChart data={attendanceData}>
              <CartesianGrid stroke="#475569" strokeDasharray="3 3" />
              <XAxis dataKey="name" stroke="#cbd5e1" tick={{ fill: '#e2e8f0' }} />
              <YAxis stroke="#cbd5e1" tick={{ fill: '#e2e8f0' }} />
              <Tooltip contentStyle={{ backgroundColor: '#0f172a', border: '1px solid #334155', color: '#f8fafc' }} />
              <Bar dataKey="present" fill="#10b981" name="Present" onClick={(data) => setSelectedMonth(data.name)} />
              <Bar dataKey="absent" fill="#ef4444" name="Absent" onClick={(data) => setSelectedMonth(data.name)} />
              <Bar dataKey="late" fill="#f59e0b" name="Late" onClick={(data) => setSelectedMonth(data.name)} />
              {attendanceData.some(d => d.holiday > 0) && <Bar dataKey="holiday" fill="#94a3b8" name="Holiday" onClick={(data) => setSelectedMonth(data.name)} />}
              {attendanceData.some(d => d.leave > 0) && <Bar dataKey="leave" fill="#8b5cf6" name="Leave" onClick={(data) => setSelectedMonth(data.name)} />}
            </BarChart>
          </ResponsiveContainer>
        ) : (
          <div className="h-96 flex items-center justify-center text-slate-300 bg-slate-800 rounded-lg">No attendance data available</div>
        )}
      </div>

      {selectedMonth && (
        <div className="bg-slate-900 rounded-xl shadow-lg p-6 border border-slate-700">
          <div className="flex justify-between items-center mb-4">
            <h3 className="text-lg font-semibold text-white">📅 Detailed Attendance for {selectedMonth}</h3>
            <button onClick={() => setSelectedMonth(null)} className="text-slate-400 hover:text-white">
              <X className="w-5 h-5" />
            </button>
          </div>
          {(() => {
            const detailedRecords = getRecordsForMonth(selectedMonth);
            if (detailedRecords.length > 0) {
              return (
                <ul className="space-y-2">
                  {detailedRecords.map(record => (
                    <li key={record._id} className="p-3 border border-slate-700 rounded-lg hover:bg-slate-800">
                      <div className="flex justify-between">
                        <span className="font-medium text-slate-100">
                          {getEmployeeName(record)} - {record.date}
                        </span>
                        <span className={`px-2 py-1 rounded-full text-xs font-medium ${record.status === 'present' ? 'bg-emerald-500/20 text-emerald-300' :
                          record.status === 'absent' ? 'bg-rose-500/20 text-rose-300' :
                            'bg-amber-500/20 text-amber-300'
                          }`}>
                          {record.status}
                        </span>
                      </div>
                      <p className="text-sm text-slate-400 mt-1">
                        In: {record.inTime || 'N/A'} | Out: {record.outTime || 'N/A'}
                      </p>
                    </li>
                  ))}
                </ul>
              );
            } else {
              return <p className="text-gray-500 text-center py-8">No records available for this month.</p>;
            }
          })()}
        </div>
      )}

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-white rounded-xl shadow-sm p-6 border border-gray-100">
          <h3 className="text-lg font-semibold text-gray-900 mb-4">📅 Recent Leaves</h3>
          {leaveData.length > 0 ? (
            leaveData.slice(0, 5).map((leave, i) => (
              <div key={i} className="p-3 border border-gray-200 rounded-lg hover:bg-gray-50 transition-all mb-2">
                <div className="flex justify-between items-center">
                  <span className="font-medium text-gray-900">
                    {getEmployeeName(leave)} - {leave.reason}
                  </span>
                  <span className="px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">{leave.status}</span>
                </div>
                <p className="text-sm text-gray-500 mt-1">
                  {new Date(leave.fromDate).toLocaleDateString('en-GB')} - {leave.toDate ? new Date(leave.toDate).toLocaleDateString('en-GB') : 'N/A'}
                </p>
              </div>
            ))
          ) : (
            <p className="text-gray-500 text-center py-8">No leaves data available</p>
          )}
        </div>
        <div className="bg-white rounded-xl shadow-sm p-6 border border-gray-100">
          <h3 className="text-lg font-semibold text-gray-900 mb-4">🎉 Upcoming Holidays</h3>
          {holidayData.length > 0 ? (
            holidayData.slice(0, 5).map((holiday, i) => (
              <div key={i} className="p-3 border border-gray-200 rounded-lg hover:bg-gray-50 transition-all mb-2">
                <h4 className="font-medium text-gray-900">{holiday.name}</h4>
                <p className="text-sm text-gray-500 mt-1">{new Date(holiday.date).toLocaleDateString('en-GB')}</p>
              </div>
            ))
          ) : (
            <p className="text-gray-500 text-center py-8">No holidays data available</p>
          )}
        </div>
      </div>

      <div className="bg-gray-50 rounded-lg p-4 text-sm text-gray-600">
        <div className="font-medium mb-2">📊 Data Summary:</div>
        <div>Total Records: {attendance.length}</div>
        <div>Today Present: {todayAttendance.present}</div>
        <div>Today Absent: {todayAttendance.absent}</div>
        <div>Months with Data: {attendanceData.filter(d => d.present > 0 || d.absent > 0).length}</div>
        <div>Employees Mapped: {Object.keys(employees).length}</div>
        <div className="mt-2 text-xs text-gray-500">
          {error ? 'Using sample data for demonstration' : 'Using real attendance data'}
        </div>
      </div>
    </div>
  );
};

export default AttendanceDashboard;

